import { Descriptions } from 'antd';
import moment from 'moment';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import { getEvent } from '../../../api/events.api';
import Button from '../../../components/Button';
import ErrorResponse from '../../../components/ErrorResponse';
import SimpleHeader from '../../../components/layout/SimpleHeader';
import Loader from '../../../components/Loader';
import useAuth from '../../../hooks/useAuth';
import useAxios from '../../../hooks/useAxios';
import { IGetEvent } from '../../../models/events.model';

interface IMatch {
  eventNo: string;
}

const BusinessSessionRead = () => {
  const { t } = useTranslation();
  const { writeAuthYn } = useAuth();
  const match = useRouteMatch<IMatch>();
  const eventNo = Number(match.params.eventNo);
  const history = useHistory();
  const location = useLocation();
  const { data: res, isLoading, error, execute } = useAxios<IGetEvent>();

  useEffect(() => {
    if (eventNo) {
      execute(getEvent('FR', eventNo));
    }
  }, [eventNo]);

  return (
    <div className="content scrollbar">
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />
      <SimpleHeader
        iconFile="icon-business-big.svg"
        parentMenu={t('common.menu.business')}
        currentMenu={t('business.session.title2')}
      />

      <div className='comm-table__area rowType'>
        <Descriptions
          bordered
          column={3}
          size="small"
          labelStyle={{ width: '16.5%' }}
          contentStyle={{ width: '16.5%' }}
        >
          <Descriptions.Item label={t('common.column.title')} span={3}>
            {res?.data?.eventName}
          </Descriptions.Item>
          <Descriptions.Item label={t('common.column.writer')}>
            {res?.data?.regMemKorName}
          </Descriptions.Item>
          <Descriptions.Item label={t('business.session.column11')} span={2}>
            {res?.data?.eventLocation}
          </Descriptions.Item>
          <Descriptions.Item label={t('business.session.column12')}>
            {moment(res?.data?.eventDate).format('YYYY.MM.DD')}{' '}
            {res?.data?.eventTime}
          </Descriptions.Item>
          <Descriptions.Item label={t('business.session.column6')}>
            {moment(res?.data?.registSrtDate).format('YYYY.MM.DD')}
          </Descriptions.Item>
          <Descriptions.Item label={t('business.session.column7')}>
            {moment(res?.data?.registEndDate).format('YYYY.MM.DD')}
          </Descriptions.Item>
          <Descriptions.Item label={t('business.session.column13')}>
          {t('business.session.column9')}{res?.data?.require} {t('business.session.column10')}
          </Descriptions.Item>
          <Descriptions.Item label={t('business.session.column4')}>
            {res?.data?.quota ? `${t('business.session.column9')}${res?.data?.quota} ${t('business.session.column10')}` : t('business.session.column8')}
          </Descriptions.Item>
          <Descriptions.Item label={t('business.session.column3')}>
            {res?.data?.openYn === 'Y' ? t('common.option.yes') : t('common.option.no')}
          </Descriptions.Item>
          <Descriptions.Item label={t('common.column.contents')} span={4}>
            <div
              dangerouslySetInnerHTML={{ __html: res?.data?.content || '' }}
            />
          </Descriptions.Item>
          <Descriptions.Item label={t('archive.exam.column7')} span={4}>
            {res?.data?.eventFiles
              ? res.data.eventFiles.map((item) => (
                  <a
                    className="download-link mr-2"
                    href={item.fileLocation}
                    download={item.originalName}
                  >
                    {item.originalName}
                  </a>
                ))
              : '-'}
          </Descriptions.Item>
        </Descriptions>

        <div className="comm-bx__between">
          <div className="comm-btn__area">
            <Button
              onClick={() =>
                history.push(`/business/session${location.search}`)
              }
              className="btn-basic gray-line"
              text={t('common.button.list')}
            />
          </div>
          <div className="comm-btn__area right">          
            <Button
              onClick={() =>
                history.push(
                  `/business/session/${res?.data?.eventNo}/edit${location.search}`,
                )
              }
              className="btn-basic pink-line"
              text={t('common.button.edit')}
              writeAuthYn={writeAuthYn}
            />
            <Button
              onClick={() =>
                history.push(`/business/session/${res?.data?.eventNo}/register`)
              }
              className="btn-basic pink-line"
              text={t('business.session.button1')}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusinessSessionRead;
